import { useMutation, useQuery } from 'react-query';
import ordersServices from './orders.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { ordersDicionary } from './orders.dicionary';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useStoneOrderHasOpenQuery(deviceId?: number, enabled = true) {
  return useQuery(
    ['stoneOrder/hasOpen', { deviceId }],
    () => ordersServices.hasOpenOrder(deviceId),
    {
      enabled: enabled && !!deviceId,
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useStoneOrderHasOpenMutate() {
  return useMutation(ordersServices.hasOpenOrder, {
    onError(err) {
      notificationError(err);
    },
  });
}

export function useStoneOrderCreate() {
  const queryChanel = useQueryChanel();

  return useMutation(ordersServices.create, {
    async onSuccess() {
      notification.info({ message: 'Pedido de pagamento enviado!' });

      queryChanel({
        invalidateQueries: [['stoneOrder/hasOpen'], ['stoneDevice/list']],
        refetchQueries: [['stoneOrder/hasOpen'], ['stoneDevice/list']],
      });
    },
    onError(err) {
      notificationError(err, {
        translate: (errors) =>
          errors.map((error) => ordersDicionary[error] || error),
      });
    },
  });
}

export function useStoneOrderCancel() {
  const queryChanel = useQueryChanel();

  return useMutation(ordersServices.cancel, {
    async onSuccess() {
      notification.info({ message: 'Pedido de cancelamento enviado!' });

      queryChanel({
        invalidateQueries: [['stoneOrder/hasOpen'], ['stoneDevice/list']],
        refetchQueries: [['stoneOrder/hasOpen'], ['stoneDevice/list']],
      });
    },
    onError(err) {
      notificationError(err, {
        translate: (errors) =>
          errors.map((error) => ordersDicionary[error] || error),
      });
    },
  });
}
